<template>
  <div id="app" class="bgwhite">
    <vue-snotify></vue-snotify>
    <Navigation v-if="currentUser"></Navigation>
    <router-view/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import Navigation from './components/Navigation.vue'

export default {
     components: { Navigation },
        computed: {
            ...mapState(['currentUser','bg', 'userProfile'])
        }
}
</script>




// WEBPACK FOOTER //
// src/App.vue